import { render, staticRenderFns } from "./stockproductpurchase.vue?vue&type=template&id=09bf4c50&scoped=true&"
import script from "./stockproductpurchase.vue?vue&type=script&lang=js&"
export * from "./stockproductpurchase.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./stockproductpurchase.vue?vue&type=style&index=1&id=09bf4c50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bf4c50",
  null
  
)

export default component.exports